export const SEARCH_UPDATE = 'SEARCH_UPDATE';
export const SET_SEARCH_ORIGIN = 'SET_SEARCH_ORIGIN';
export const SET_SEARCH_DESTINY = 'SET_SEARCH_DESTINY';
export const SET_SEARCH_DATE = 'SET_SEARCH_DATE';
export const SET_SEARCH_MORE_START_DATE = 'SET_SEARCH_MORE_START_DATE';
export const SET_SEARCH_MORE_END_DATE = 'SET_SEARCH_MORE_END_DATE';
export const SET_TRAVELLERS = 'SET_TRAVELLERS';
